import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import _ from 'lodash';
let DataSeparateService = class DataSeparateService {
    constructor(workspaceApi) {
        this.workspaceApi = workspaceApi;
    }
    separateData(params) {
        /** 去除空值属性 */
        let _params = { ...params };
        if (!params.space_id) {
            _params = _.omit(params, ['space_id']);
        }
        /**
         * 如果是 string 就转为number 。
         * v-modal input number ,修改时，默认是 string
         * */
        if (_params.separation_time && _.isString(_params.separation_time)) {
            _params.separation_time = parseInt(_params.separation_time);
        }
        if (_params.workspace_size && _.isString(_params.workspace_size)) {
            _params.workspace_size = parseInt(_params.workspace_size);
        }
        return this.workspaceApi.separateData(_params);
    }
    mergeData(params) {
        return this.workspaceApi.mergeData(params);
    }
};
DataSeparateService = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceApi)),
    __metadata("design:paramtypes", [Object])
], DataSeparateService);
export { DataSeparateService };
